import { normalizeScanCode } from '@/helpers/scanCode'

const JOGGER_SIZES = {
  xs: '26',
  s: '28',
  m: '30',
  l: '32',
  xl: '34',
  xxl: '36'
}

export function getPackRecordLabel (parsed) {
  if (!parsed || parsed.type === 'product') return 'registro'
  if (parsed.type === 'order') return `orden ${parsed.queryId}`
  return `cambio c${parsed.queryId}`
}

export function getPackRecordFetchErrorMessage (parsed, { response, error, notFound } = {}) {
  const label = getPackRecordLabel(parsed)

  if (response && response.error) {
    return `Error al buscar ${label}: ${response.error}`
  }

  if (error) {
    const detail = error.message || String(error)
    return `Error al buscar ${label}: ${detail}`
  }

  if (notFound) {
    return `No se encontró ${label} en la base de datos`
  }

  return `No se pudo buscar ${label}`
}

export function hasActivePackFilters (packFilters) {
  if (!packFilters) return false
  return !!(packFilters.bassica || packFilters.sahet || packFilters.bogota || packFilters.nacional)
}

export function matchesPackRecordFilters (record, packFilters) {
  if (!record || !hasActivePackFilters(packFilters)) return true

  const brand = String(record.brand || '').toLowerCase()
  const location = String(record.location || '').toLowerCase()
  const brandFilters = []

  if (packFilters.bassica) brandFilters.push('bassica')
  if (packFilters.sahet) brandFilters.push('sahet')

  if (brandFilters.length && brandFilters.indexOf(brand) === -1) return false

  const locationFilters = []
  if (packFilters.bogota) locationFilters.push('bogota')
  if (packFilters.nacional) locationFilters.push('nacional')

  if (!locationFilters.length) return true

  const isBogota = location === 'bogota'
  const matchesBogota = locationFilters.indexOf('bogota') !== -1 && isBogota
  const matchesNacional = locationFilters.indexOf('nacional') !== -1 && !isBogota

  return matchesBogota || matchesNacional
}

export function parsePackSearchInput (value) {
  const text = (value || '').trim()
  if (!text) return null

  const first = text[0].toLowerCase()

  if (first === 'c') {
    const changeId = text.slice(1).trim()
    if (!changeId) return null
    return { type: 'change', queryId: changeId }
  }

  if (first === 's') {
    return { type: 'order', queryId: text }
  }

  return { type: 'product', productCode: text }
}

export function formatChangeCode (changeId) {
  return `c${changeId}`
}

export function getPackRouteCode (record) {
  if (!record || !record.type) return null

  const data = record.data

  if (record.type === 'order') {
    return (data && data.order) || record.code || null
  }

  if (data && data.change !== undefined && data.change !== null) {
    return formatChangeCode(data.change)
  }

  return record.code || null
}

export function recordMatchesParsed (record, parsed) {
  if (!record || !parsed || parsed.type === 'product') return false

  const data = record.data

  if (parsed.type === 'order') {
    return record.type === 'order' && data && data.order === parsed.queryId
  }

  if (parsed.type === 'change') {
    return record.type === 'change' && data && String(data.change) === String(parsed.queryId)
  }

  return false
}

export function parsePackRouteCode (code) {
  if (!code) return null
  return parsePackSearchInput(decodeURIComponent(code))
}

export function fixCodeJogger (code, sizes = JOGGER_SIZES) {
  if (!code) return code
  code = normalizeScanCode(code)
  const isJogger = code.slice(0, 2) === 'hj'

  if (!isJogger) return code

  const codeArray = code.split('-')
  const reference = codeArray[0]
  const size = codeArray[1]

  if (!reference || !size) return code

  const sizeFixed = sizes[size]

  if (!sizeFixed) return code

  return `${reference}-${sizeFixed}`
}

export function parseProductCode (codeString) {
  const code = fixCodeJogger(normalizeScanCode(codeString || ''))

  if (!code) return null

  const productSplit = code.split('-')

  if (productSplit.length !== 2) return null

  const nameProduct = productSplit[0]
  const size = productSplit[1]

  if (nameProduct && size) {
    return { product: nameProduct, size }
  }

  return null
}



// WEBPACK FOOTER //
// ./src/helpers/packSearch.js